import React, { FunctionComponent } from "react";
import makeStyles from '@mui/styles/makeStyles';

export const Up: FunctionComponent = () => {
    const classes = useStyles()
    return (
        <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.8613 5.24658L5.87948 -4.58671e-07L0.897636 5.24658L10.8613 5.24658Z" fill="#FF6259"/>
        </svg>
    )
}

export const InPlace: FunctionComponent = () => {
    const classes = useStyles()
    return (
        <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.76885 0.5L0.76885 2.83333L8.52344 2.83333L8.52344 0.5L0.76885 0.5ZM8.52344 5.16667L0.76885 5.16667L0.76885 7.5L8.52344 7.5L8.52344 5.16667Z" fill="#195190"/>
        </svg>
    )
}

export const Down: FunctionComponent = () => {
    const classes = useStyles()
    return (
        <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.900391 0.753418L5.88224 6L10.8641 0.75342L0.900391 0.753418Z" fill="#195190"/>
        </svg>
    )
}

const useStyles = makeStyles({})
